import { Button, DatePicker, Input, Select, Tooltip } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import SearchIcon from "../../../../Assets/svg/searchIcon.svg";
import { httpService } from "../../../../services/httpService.service";

import { debounce } from "lodash";
import { siteVisitStatusEnum } from "../../../../services/Enums/siteVisitStatusEnum";
import { months, years } from "../../../../services/Enums/monthsAndYears";
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
const { Option } = Select;

const Filters = ({
  filters,
  setFilters,
  pagination,
  setPagination,
  onFiltersChange,
  inputSearch,
  setInputSearch,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [implementingPartners, setImplementingPartners] = useState();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [sampleSizes, setSampleSizes] = useState([]);
  const [allCountries, setAllContries] = useState([]);
  const [filtersValue, setFiltersValue] = useState({
    Search: "",
    ImplementingPartnerId: [],
    State: [],
    SiteVisitStatus: [],
    ClusterId: [],
    Month: [],
    Year: [],
    Governates: [],
    Cities: [],
    DataCheckIds: [],
    IsStalled: null,
  });

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleClearAll = () => {
    setFilters({
      Search: "",
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      ClusterId: [],
      Month: [],
      Year: [],
      Governates: [],
      Cities: [],
      DataCheckIds: [],
      IsStalled: null,
    });
    setFiltersValue({
      Search: "",
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      ClusterId: [],
      Month: [],
      Year: [],
      Governates: [],
      Cities: [],
      DataCheckIds: [],
      IsStalled: null,
    });
    setPagination({ ...pagination, current: 1 });
    setInputSearch("");
    setCities([]);
    setStates([]);
  };

  // F-03 — "Stalled only", the site-visit twin of the task queue's stalled
  // toggle. Applied server-side (IsStalled), so it pages correctly. Set
  // immediately rather than debounced: it's a single click, not typing.
  const handleStalledToggle = () => {
    const next = filtersValue.IsStalled ? null : true;
    setFiltersValue((prevFilters) => ({ ...prevFilters, IsStalled: next }));
    setFilters((prevFilters) => ({ ...prevFilters, IsStalled: next }));
    setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
    onFiltersChange({ IsStalled: next });
  };

  const debouncedHandler = useCallback(
    debounce((filter) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ...filter,
      }));
      setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));

      onFiltersChange({ ...filter });
    }, 1000),
    []
  );

  const handleSearchChange = (e) => {
    const search = e.target.value;
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Search: search,
    }));
    debouncedHandler({ Search: search });
  };

  const handleIp = (ip) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      ImplementingPartnerId: ip,
    }));
    debouncedHandler({ ImplementingPartnerId: ip });
  };

  const handleProgressStatus = (progressStatus) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      SiteVisitStatus: progressStatus,
    }));
    debouncedHandler({ SiteVisitStatus: progressStatus });
  };

  const handleLocation = (location) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      State: location,
    }));
    debouncedHandler({ State: location });
  };

  const handleStateChange = (value) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Governates: value,
    }));
    debouncedHandler({ Governates: value });
  };

  const handleCityChange = (Cities) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Cities: Cities,
    }));
    debouncedHandler({ Cities: Cities });
  };

  const handleCluster = (cluster) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      ClusterId: cluster,
    }));
    debouncedHandler({ ClusterId: cluster });
  };

  const handleSampleSizeChange = (sampleSize) => {
    debouncedHandler({ DataChecksId: sampleSize });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      DataChecksId: sampleSize,
    }));
  };

  const handleMonth = (month) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Month: month,
    }));
    debouncedHandler({ Month: month });
  };

  const handleYear = (year) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Year: year,
    }));
    debouncedHandler({ Year: year });
  };

  useEffect(() => {
    httpService.get(
      `/api/Site/getCountriesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCountries = new Set();

        const formattedData = data
          .map((country) => country.trim()) // Trim first
          .filter((country) => {
            if (
              country === "string" ||
              country === "undefined" ||
              country === ""
            )
              return false; // Remove invalid values

            if (uniqueCountries.has(country)) return false; // Remove duplicates

            uniqueCountries.add(country); // Add to Set before proceeding
            return true;
          })
          .map((country, index) => ({
            id: index,
            stateName: country,
          }));

        setAllContries(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getStatesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueStates = new Set();

        const formattedData = data
          .map((state) => state.trim()) // Trim first
          .filter((state) => {
            if (state === "string" || state === "undefined" || state === "")
              return false; // Remove invalid values

            if (uniqueStates.has(state)) return false; // Remove duplicates

            uniqueStates.add(state); // Add to Set before proceeding
            return true;
          })
          .map((state, index) => ({
            id: index,
            stateName: state,
          }));

        setStates(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getCitiesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCities = new Set();

        const formattedData = data
          .map((city) => city.trim()) // Trim first
          .filter((city) => {
            if (city === "string" || city === "undefined" || city === "")
              return false; // Remove invalid values

            if (uniqueCities.has(city)) return false; // Remove duplicates

            uniqueCities.add(city); // Add to Set before proceeding
            return true;
          })
          .map((city, index) => ({
            id: index,
            name: city,
          }));

        setCities(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    const apiClusters = "/api/Site/getAllClusters";
    httpService.get(
      apiClusters,
      (res) => setClusters(res.data)
      // (error) => console.log(error)
    );

    const workspaceId = localStorage.getItem("currentContractId");
    const apiIps = `/api/ImplementingPartner/getAllImplementingPartners?contractId=${workspaceId}&IgnorePagination=true`;

    httpService.get(
      apiIps,
      (res) => setImplementingPartners(res.data)
      // (error) => console.log(error)
    );

    const apiSampleSizes = `/api/Datachecks/getAll?projectId=${localStorage.getItem(
      "currentProjectID"
    )}`;
    httpService.get(
      apiSampleSizes,
      (res) => {
        setSampleSizes(res.data);
      },
      (error) => {
        // console.log(error)
      }
    );
  }, []);

  return (
    <div className="filtersWrapper">
      <div className="containerFilters">
        {" "}
        <Input
          placeholder="Search..."
          onChange={handleSearchChange} // Correct prop name
          suffix={<img src={SearchIcon} alt="search icon" />}
          value={filtersValue.Search || ""}
        />
        <Tooltip title="Show only visits with no update for longer than the escalation threshold">
          <Button
            className={`stalledOnlyToggle ${
              filtersValue.IsStalled ? "stalledOnlyToggleActive" : ""
            }`}
            onClick={handleStalledToggle}
          >
            Stalled only
          </Button>
        </Tooltip>
        <Button className="clearButton" onClick={handleClearAll}>
          Clear All
        </Button>
        <Button onClick={handleToggleFilters} className="toggleButton">
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </div>
      {showFilters && (
        <div className="filtersContainer">
          <div className="filter">
            <p className="filterText">Implementing Partner</p>
            <Select
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select the IP"
              allowClear
              showSearch
              mode="multiple"
              value={
                filtersValue.ImplementingPartnerId
                  ? filtersValue.ImplementingPartnerId
                  : undefined
              }
              onChange={handleIp}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {implementingPartners &&
                implementingPartners.map((implementingPartner) => (
                  <Option
                    key={implementingPartner.id}
                    value={implementingPartner.id}
                  >
                    {implementingPartner.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Progress Status</p>
            <Select
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a progress status"
              allowClear
              showSearch
              value={
                filtersValue.SiteVisitStatus
                  ? filtersValue.SiteVisitStatus
                  : undefined
              }
              mode="multiple"
              onChange={handleProgressStatus}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {Object.entries(siteVisitStatusEnum)
                .filter(([key]) => key !== "default" && key > 1 && key < 4)
                .map(([key, value]) => (
                  <Option value={Number(key)}>{value.text}</Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Cluster</p>
            <Select
              onChange={handleCluster}
              value={
                filtersValue.ClusterId ? filtersValue.ClusterId : undefined
              }
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a cluster"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {clusters &&
                clusters.map((cluster) => (
                  <Option key={cluster.id} value={cluster.id}>
                    {cluster.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Month </p>
            <Select
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select month"
              onChange={handleMonth}
              allowClear
              mode="multiple"
              showSearch
              value={filtersValue.Month ? filtersValue.Month : undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {Object.entries(months).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Year</p>
            <Select
              onChange={handleYear}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select year"
              value={filtersValue.Year ? filtersValue.Year : undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {years.map((year, index) => (
                <Option key={index} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </div>

          <div className="filter">
            <p className="filterText">
              <Tooltip title="Countries not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Country
            </p>
            <Select
              onChange={handleLocation}
              value={filtersValue.State ? filtersValue.State : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {allCountries &&
                allCountries.map((country) => (
                  <Option key={country.id} value={country.stateName}>
                    {country.stateName}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="States not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Governorate/State
            </p>
            <Select
              onChange={handleStateChange}
              value={
                filtersValue.Governates ? filtersValue.Governates : undefined
              }
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {states.map((state) => (
                <Option key={state.id} value={state.stateName}>
                  {state.stateName}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Cities not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              City
            </p>
            <Select
              onChange={handleCityChange}
              value={filtersValue.Cities ? filtersValue.Cities : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {cities.map((city) => (
                <Option key={city.id} value={city.name}>
                  {city.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Sample Size</p>
            <Select
              showSearch
              mode="multiple"
              allowClear
              onChange={handleSampleSizeChange}
              value={filtersValue.DataChecksId || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a sample size"
            >
              {sampleSizes &&
                sampleSizes.map((sampleSizes, index) => (
                  <Option key={index} value={sampleSizes.id}>
                    {sampleSizes.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
